module.exports = __webpack_public_path__ + "static/media/error_unknown_img.44ebeb06.png";